var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArchiveIconButton = function SvgArchiveIconButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#00C193",
    rx: 8,
    style: {
      WebkitTransform: "translateZ(0)",
      transform: "translateZ(0)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.333 9.333h-5c-.917 0-1.658.75-1.658 1.667l-.008 10c0 .917.75 1.667 1.666 1.667h13.333c.917 0 1.667-.75 1.667-1.667v-8.333c0-.917-.75-1.667-1.666-1.667H16z"
  })));
};
export default SvgArchiveIconButton;